const SmallLoader = () => {
  return (
    <div className="h-4 w-4 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
  );
};

export default SmallLoader;
